<template>
  <div>
    <button class="btn main-btn py-2 mt-2" @click="AddToCart">Add to cart</button>
  </div>
</template>

<script>
export default {
  name: "add-to-cart-btn",
  props: ["product"],
  methods: {
      // showModal() {
      //   this.$bvModal.show('cart-modal');
      // },
    AddToCart() {
      let ProductItem = {
        ...this.product,
        quantity: 1
      };

      this.$store.commit("cartModule/addCartItem", ProductItem);
      // this.showModal();
    }
  }
};
</script>
